import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '@otcmarketsgroup/otcm-ui-lib';

const NextButton = (props) => {
  return (
    <Button variant='outlined' fullWidth endIcon={<ChevronRight size={14} />} {...props}>
      Next
    </Button>
  );
};

export default NextButton;
